
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getGetTasksForProjectIdsDtoFormGroup() {
return new FormGroup({
    projectIds: new FormControl<Array<number> | undefined>([], [Validators.required]),
})
;
}
      